import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ContratoService from '../../../../services/contrato-auth';
import LicService from '../../../../services/licitacao-auth';



const Contrato = () => {
    const [processo, setProcesso] = useState("");
    const [numero, setNumero] = useState("");
    const [inicioVigencia, setInicioVigencia] = useState("");
    const [finalVigencia, setFinalVigencia] = useState("");
    const [situacao, setSituacao] = useState("");
    const [ano, setAno] = useState("");
    const [dataAssinatura, setDataAssinatura] = useState("");
    const [dataPub, setDataPub] = useState("");
    const [contratado, setContratado] = useState("");
    const [cnpj, setCnpj] = useState("");
    const [anexos, setAnexos] = useState([]);
    const [lics, setLics] = useState([]);
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    const montaLicita = async () => {
        const licita = await ContratoService.pegaLic({ situacao: "Homologada" })
        setLics(licita.data)
        setAno(licita.data["ano"])
    }

    useEffect(() => {
        montaLicita()
    }, [])



    const montaForm = async () => {
        const lic = new FormData();
        lic.append("id", processo)
        lic.append("numero", numero)
        lic.append("inicioVigencia", inicioVigencia)
        lic.append("finalVigencia", finalVigencia)
        lic.append("ano", ano)
        lic.append("situacao", situacao);
        lic.append("dataAssinatura", dataAssinatura);
        lic.append("dataPub", dataPub);
        lic.append("contratado", contratado);
        lic.append("cnpj", cnpj);
        for (let i = 0; i < anexos.length; i++) {
            lic.append('anexos', anexos[i]);
        }
        return lic
    }

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        const dados = await montaForm();
        try {
            const lic = await ContratoService.chamamento(dados)
            if (lic.data["cod_contrato"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }


    const handleUploadDocumentos = (event) => {
        const files = event.target.files;
        setAnexos(files);
    };


    const addNovo = (evt) => {
        evt.preventDefault()
        setSucesso(false)
        setProcesso("");
        setNumero("");
        setInicioVigencia("");
        setFinalVigencia("");
        setSituacao("");
        setDataAssinatura("");
        setDataPub("");
        setContratado("");
        setCnpj("");
        setAnexos([]);
        setError([]);
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={4}>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="Processo">
                                <FloatingLabel
                                    label="Processo Licitatório"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Processo Licitatório"
                                        name="processo"
                                        onChange={e => setProcesso(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        {lics.map((lic) =>
                                            <option value={lic._id}>{lic.processo}/{lic.ano}</option>
                                        )}
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="numero">
                                <FloatingLabel
                                    label="Número do Contrato"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="numero"
                                        value={numero}
                                        onChange={e => setNumero(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="ano">
                                <FloatingLabel
                                    label="Ano"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Ano"
                                        name="ano"
                                        onChange={e => setAno(e.target.value)}
                                    >
                                        <option value={ano}>{ano}</option>
                                        <option value="2025">2025</option>
                                        <option value="2024">2024</option>
                                        <option value="2023">2023</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2020">2020</option>
                                        <option value="2019">2019</option>
                                        <option value="2018">2018</option>
                                        <option value="2017">2017</option>
                                        
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="incicioVigencia">
                                <FloatingLabel
                                    label="Início da Vigência"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="inicioVigencia"
                                        value={inicioVigencia}
                                        onChange={e => setInicioVigencia(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="finalVigencia">
                                <FloatingLabel
                                    label="Final da Vigência"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="date"
                                        name="finalVigencia"
                                        value={finalVigencia}
                                        onChange={e => setFinalVigencia(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="Situação">
                                <FloatingLabel
                                    label="Situação"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Situação"
                                        name="situacao"
                                        onChange={e => setSituacao(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="Ativo">Ativo</option>
                                        <option value="Concluído">Concluído</option>
                                        <option value="Cancelado">Cancelado</option>
                                        <option value="Rescindido">Rescindido</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="dataAssinatura">
                                <FloatingLabel
                                    label="Data da Ratificação"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="date"
                                        name="dataAssinatura"
                                        value={dataAssinatura}
                                        onChange={e => setDataAssinatura(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="dataPub">
                                <FloatingLabel
                                    label="Data da Publicação"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="date"
                                        name="dataPub"
                                        value={dataPub}
                                        onChange={e => setDataPub(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="contratado">
                                <FloatingLabel
                                    label="Razão Social do Contratado"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="contratado"
                                        value={contratado}
                                        onChange={e => setContratado(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="cnpj">
                                <FloatingLabel
                                    label="CPF/CNPJ"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="cnpj"
                                        value={cnpj}
                                        onChange={e => setCnpj(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col lg={4}>
                            <Form.Group className="mb-3" controlId="aviso">
                                <Form.Label>Anexos</Form.Label>
                                <Form.Control
                                    type="file"
                                    name="documentos"
                                    onChange={handleUploadDocumentos}
                                    accept=".pdf, .xlsx., xls"
                                    multiple // Permite múltiplos arquivos
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Cadastrar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/contratos'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Contrato cadastrado com sucesso!</Alert>
                <Button onClick={addNovo} variant="success" type="submit">
                    Adicionar outro
                </Button>
                <br /><br />
                <Link to={'/restrito/contratos/listar'}>
                    <Button variant="primary" type="button">
                        Ir para Listagem de Contratos
                    </Button>
                </Link>
                <br /><br />
                <Link to={'/restrito/contratos'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default Contrato;